
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsPromoApHdDialog extends Serenity.EntityDialog<PsPromoApHdRow, any> {
        protected getFormKey() { return PsPromoApHdForm.formKey; }
        protected getIdProperty() { return PsPromoApHdRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoApHdRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoApHdRow.nameProperty; }
        protected getService() { return PsPromoApHdService.baseUrl; }
        protected getDeletePermission() { return PsPromoApHdRow.deletePermission; }
        protected getInsertPermission() { return PsPromoApHdRow.insertPermission; }
        protected getUpdatePermission() { return PsPromoApHdRow.updatePermission; }

        protected form = new PsPromoApHdForm(this.idPrefix);

        constructor() {
            super();


        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "Approve",
                    hint: "Approve and Save [alt+s]",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        // var plucode = Q.toId(this.form.PluCode.value)
                        // this.price1 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice1;
                        // this.price2 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice2;
                        // this.price3 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice3;
                        // this.price4 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice4;
                        // this.price5 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice5;
                        // this.price6 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice6;

                        Q.confirm(
                            // "ราคาเดิม (อ้างอิง ณ ปัจจุบัน) > ราคาที่กำหนดใหม่" + "\r\n" +
                            // this.price1 + " > " + this.form.SellUnitPrice1.value + "\r\n" +
                            // this.price2 + " > " + this.form.SellUnitPrice2.value + "\r\n" +
                            // this.price3 + " > " + this.form.SellUnitPrice3.value + "\r\n" +
                            // this.price4 + " > " + this.form.SellUnitPrice4.value + "\r\n" +
                            // this.price5 + " > " + this.form.SellUnitPrice5.value + "\r\n" +
                            // this.price6 + " > " + this.form.SellUnitPrice6.value + "\r\n" +
                            '  ยืนยันการอนุมัติ'+ "\r\n" +
                           'และเปิดใช้งานโปรโมชั่น'+"\r\n" +
                           'หากต้องการยกเลิกการอนุมัติ โปรดปิดสถานะการใช้งานก่อน',
                            () => {
                                this.form.PromoApproveFg.value = "1";
                                this.form.PromoStatus.value = "1";
                                this.form.PromoApproveFg.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                let newSaveRejectedBtn: Serenity.ToolButton =
                {
                    title: "ไม่อนุมัติ",
                    hint: "Rejected and Save",
                    separator: false,
                    cssClass: "button-save-reject",
                    icon: "fa fa-save",
                    // hotkey: 'alt+s',
                    onClick: (e) => {
                        Q.confirm(
                            "ไม่อนุมัติรายการนี้ " + "\r\n" +
                            ' ยืนยันการบันทึก',
                            () => {
                                this.form.PromoApproveFg.value = "0";
                                this.form.PromoStatus.value = "0";
                                // this.form.PromoApproveFg.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveRejectedBtn);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            let newSaveRejectedBtn: Serenity.ToolButton =
            {
                title: "ยกเลิกการอนุมัติ",
                hint: "Cancle and Save",
                separator: false,
                cssClass: "button-save-cancle",
                icon: "fa fa-save",
                // hotkey: 'alt+s',
                onClick: (e) => {
                    Q.confirm(
                        "ยกเลิกการอนุมัติรายการนี้ "
                        ,
                        () => {
                            this.form.PromoApproveFg.value = null;
                            this.form.PromoApproveFg.forceUpdate();
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                }
            }
            buttons.push(newSaveRejectedBtn);

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.syscuscheck();

            if (this.isEditMode){
            this.toolbar.findButton('delete-button').hide();
            this.toolbar.findButton('button-apply').hide();
            var date = $.datepicker.formatDate('yymmdd', new Date());
            var effdate = this.entity.EndPromoDate
            var a = effdate.split('T')[0];
            var effectdate = a.split('-')[0] + a.split('-')[1] + a.split('-')[2]
            // Q.confirm(effectdate + date, () => { });
            if (effectdate < date) {
            // if (this.entity.PromoApproveFg == 1) {
                this.toolbar.findButton('button-save-approve').hide();
                this.toolbar.findButton('button-save-reject').hide();
                this.toolbar.findButton('button-save-cancle').hide();
            // }else if (this.entity.PromoApproveFg == 0) {
            //     this.toolbar.findButton('button-save-cancle').hide();
            //     this.toolbar.findButton('button-save-approve').hide();

            //     // this.toolbar.findButton('button-save-reject').hide();                  
            // }else{
            //     this.toolbar.findButton('button-save-approve').hide();

            //     this.toolbar.findButton('button-save-cancle').hide();     
            //     //ต้องการเพิ่มซ่อน from.ApproveFg
            // }
            }else{
            if (this.entity.PromoApproveFg == 1) {
                if (this.entity.PromoStatus == 1) {
                    this.toolbar.findButton('button-save-approve').hide();
                    this.toolbar.findButton('button-save-cancle').hide();
                    this.toolbar.findButton('button-save-reject').hide();
                } else {
                    this.toolbar.findButton('button-save-approve').hide();
                    this.toolbar.findButton('button-save-reject').hide();

                }
            }
            else if (this.entity.PromoApproveFg == 0) {
                this.toolbar.findButton('button-save-cancle').hide();
                this.toolbar.findButton('button-save-reject').hide();
            }
            else {
                this.toolbar.findButton('button-save-cancle').hide();
                //ต้องการเพิ่มซ่อน from.ApproveFg
            }
            }}

        }

        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 14 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.VenderSharing.getGridField().toggle(true);
            } else {
                this.form.VenderSharing.getGridField().toggle(false);
            }

        }

    }
}